/* eslint-disable max-len */
import faq_message from "./message_faq_nl.js";
import privacy_message from "./message_privacy_nl.js";

export default {
  error: {
    apicall: 'Er is iets misgegaan op de api-server!',
    UserNotFoundException: 'Gebruiker bestaat niet.',
    NotAuthorizedException: 'Onjuiste gebruikersnaam of wachtwoord.',
    ChangePasswordNotAuthorizedException: 'Oud wachtwoord onjuist.',
    LimitExceededException: 'Poging limiet overschreden, probeer het na een tijdje.',
    UsernameExistsException: 'Er bestaat al een account met dit e-mailadres.',
    InvalidParameterExceptionPassword: 'Het wachtwoord voldoet niet aan de complexiteitsvereisten: het wachtwoord moet uit minimaal 8 tekens bestaan.',
    InvalidPasswordExceptionLong: 'Het wachtwoord voldoet niet aan de complexiteitsvereisten: het wachtwoord is te kort.',
    InvalidPasswordExceptionLower: 'Het wachtwoord voldoet niet aan de complexiteitsvereisten: het wachtwoord moet ten minste één kleine letter bevatten.',
    InvalidPasswordExceptionUpper: 'Het wachtwoord voldoet niet aan de complexiteitsvereisten: het wachtwoord moet minimaal één hoofdletter bevatten.',
    InvalidPasswordExceptionNumeric: 'Het wachtwoord voldoet niet aan de complexiteitsvereisten: het wachtwoord moet ten minste één nummer bevatten.',
    InvalidPasswordExceptionSymbol: 'Het wachtwoord voldoet niet aan de complexiteitsvereisten: het wachtwoord moet ten minste één van de bovenstaande speciale tekens bevatten.',
    similar: 'Er bestaat al een gebruiker met dezelfde naam en geboortedatum. Voer een opmerking in om deze te onderscheiden.',
    alreadyAssignedImei: 'IMEI is al toegewezen aan een bestuurder.',
    NetworkingError: 'Hmm ...het lijkt erop dat je niet langer verbonden bent met internet.',
  },
  accountMenu: {
    settings: 'Wachtwoord wijzigen',
    logout: 'Uitloggen',
    language: 'Taal',
    languageFr: 'Français',
    languageNl: 'Nederlands',
    languageDe: 'Deutsch',
    languageEn: 'English',
  },
  login: {
    welcome1: 'Welkom bij het programma "Verandering van snelheidsgedrag".',
    welcome2: 'Meld u aan om toegang te krijgen tot uw gegevens.',
    email: 'E-mailadres',
    emailPlaceholder: 'Voer uw e-mailadres in',
    password: 'Wachtwoord',
    passwordPlaceholder: 'Voer uw wachtwoord in',
    rememberMe: 'Onthoud mijn gegevens',
    forgottenPassword: 'Vergeten ?',
    connect: 'Inloggen',
    connectBussy: 'Inloggen …',
    definePassword: 'Verander uw wachtwoord',
    instructions: {
      title: 'Uw nieuwe wachtwoord moet ten minste bevatten:',
      characters: 'tekens',
      uppercase: 'hoofdletter',
      number: 'getal',
      symbol: 'symbool',
    },
    definePasswordButton: 'Verander wachtwoord',
    definePasswordButtonBussy: 'Verander wachtwoord...',
  },
  signup: {
    emailLabel: 'E-mail',
    emailPlaceholder: 'Voer uw e-mailadres in',
    passwordLabel: 'Kies een wachtwoord',
    passwordPlaceholder: 'Kies een wachtwoord',
    confirmPasswordLabel: 'Wachtwoord bevesteging',
    confirmPasswordPlaceholder: 'Voer het wachtwoord opnieuw in',
    confirmationCodeLabel: 'Bevestigingscode',
    confirmationCodePlaceholder: 'Voer de bevestigingscode in',
    confirmationCodeHelp: 'Controleer alstublieft uw e-mails. U ontvangt een bevestigingscode.',
    registerButton: 'Bevestigen',
    registerBussy: 'Registratie...',
    allreadyAccountQuestion: 'Je hebt al een VIAS DBIP account?',
    connectHere: 'Log hier in',
    oldPasswordPlaceholder: 'Voer uw oude wachtwoord in.',
    oldPasswordLabel: 'Oud wachtwoord',
  },
  forgot: {
    reinitPassword: 'Wachtwoord opnieuw instellen',
    mailsent: 'Email verzonden',
    anEmailHasBeenSent: 'Er is een e-mail verzonden.',
  },
  menu: {
    title: {
      driversShort: 'Bestuurders',
      drivers: 'Toegewezen Bestuurders',
      users: 'Admin Dashboard',
      calendar: 'Kalender',
      contested: 'Geschillen',
    },
  },
  adminDashboard: {
    tabs: {
      drivers: 'Bestuurders',
      psychologists: 'Psychologen',
      admins: 'Administrators',
    },
    users: {
      firstName: 'Voornaam',
      lastName: 'Naam',
      birthdate: 'Geboorte datum',
      email: 'Email',
      comment: 'Opmerking',
      search: 'Zoeken',
      new: 'Nieuwe',
      edit: 'Bewerken',
      delete: 'Verweideren',
      confirmDeleteTitle: 'Weet u zeker dat u wilt verwijderen?',
      deleteOk: 'Bevestigen',
      deleteCancel: 'Annuleren',
      clickEnterComment: 'Voer een opmerking in.',
    },
    drivers: {
      birthdate: 'Geboorte datum',
      psychologist: 'Psycholoog',
      imei: 'IMEI',
    },
    psychologist: {
      assigned: 'Aantal toegewezen bestuurders',
      drivers: 'bestuurder(s)',
    },
  },
  driverActions: {
    tabs: {
      calendar: 'Kalender',
      stats: 'Statistieken',
      errorManagement: 'Bestreden snelheidsoverschrijdingen',
      followUp: 'Doelstellingen en begeleiding',
    },
  },
  calendar: {
    event: {
      plugged: 'Black box aangesloten',
      unplugged: 'Black box losgekoppeld',
    },
    messages: {
      date: 'Datum',
      time: 'Uur',
      event: 'Afspraak',
      allDay: 'de hele dag',
      week: 'week',
      work_week: 'werkweek',
      day: 'dag',
      month: 'maand',
      previous: 'vorige',
      next: 'volgende',
      yesterday: 'gisteren',
      tomorrow: 'morgen',
      today: 'vandaag',
      agenda: 'agenda',
      more: 'meer',
    },
  },
  driverSelection: {
    name: 'Naam',
    birthdate: 'Geboortedatum',
    lastConsultation: 'Laatste bezoek',
    disconnected: 'Losgekoppeld',
    constested: 'Betwiste oversnelheden',
    speeding: 'Oversnelheid',
  },
  contested: {
    date: 'Datum',
    driver: 'Bestuurder',
    location: 'Plaats',
    action: 'Actie',
    errorType: 'Type fout',
    errorReason: 'Rechtvaardiging',
  },
  faq:{
    faq_message
  },
  privacy:{
    privacy_message
  },
  journeyDetails: {
    indexTitle: 'Reis {index} op {total}',
    speeding: 'Snelheidsoverschrijdingen',
    severityTitle: 'Gravity',
    severity: {
      noOverSpeed: 'Geen snelheidsoverschrijding',
      small: 'Klein',
      medium: 'Gemiddeld',
      large: 'Serieus',
      xlarge: 'Zeer serieus',
    },
    speed: 'Snelheid',
    limit: 'Beperking',
    time: 'Uur',
    duration: 'Duur van het segment',
    street: 'Adres',
    gps: 'GPS',
    reportError: 'Fout melden',
    acceptError: 'Aannemen',
    rejectError: 'Afwijzen',
    overspeed: 'Overmatige snelheid',
    parameter: {
      start: 'Vertrektijd',
      end: 'Tijd van aankomst',
      distance: 'Afgelegde afstand',
      avgSpeed: 'Gemiddelde snelheid',
      maxSpeed: 'Max. snelheid',
    },
    itemsSelected: '{value, plural, one {item geselecteerd} other {items geselecteerd}}',
  },
  contestDialog: {
    title: 'Geef een fout aan',
    errorType: 'Type fout',
    selectErrorType: 'Selecteer het type fout',
    errorTypes: {
      mapmatching: 'Onjuiste map matching',
      cartography: 'Cartografische fout',
      speedlimit: 'Onjuiste snelheidslimiet',
      other: 'Andere',
    },
    reason: 'Rechtvaardiging',
    forValidation: 'Voor validatie',
    retour: 'Terug',
  },
  stats: {
    period: {
      overall: 'Globaal',
      today: 'Vandaag',
      yesterday: 'Gisteren',
      currentWeek: 'Deze week',
      lastWeek: 'Laatste week',
      currentMonth: 'Dezen maand',
      lastMonth: 'Laatste maand',
    },
    behaviour: {
      accelerations: 'Versnellingen',
      brakings: 'Remstroten',
    },
    grouping: {
      dayly: 'Dagelijkse',
      weekly: 'Wekelijkse',
      monthly: 'Maandelijkse',
      dayOfWeek: 'Dagen van de week',
      hourOfDay: 'Uren van de dag',
      groupOfHourOfDay: 'Gegroepeerde uren van de dag',
      limit: 'Per snelheidsbeperking',
    },
    charts: {
      numberOfOverspeeds: 'Aantal snelheidsoverschrijdingen',
      numberOfEvents: 'Aantal evenementen',
      totalOverspeeds: {
        title: 'Totaal overtredingen',
      },
      overspeedsBySeverity: {
        title: 'Ernst details',
      },
      totalOverspeedsBySeverity: {
        title: 'Totaal ernst / periode',
      },
      behaviourChart: {
        title: 'Remstroten/versnellingen',
      },
    },
  },
  followUp: {
    buttons: {
      new: 'Nieuw',
      save: 'Opslaan',
      cancel: 'Annuleren',
    },
    comment: 'Commentaar',
    commentPlaceholder: 'Voer hier opmerkingen over de bestuurder in.',
    objective: 'Objectieven',
    objectivePlaceholder: 'Voer hier de doelstellingen in.',
  },
  'react-intl-formatted-duration': {
    duration: '{value} {unit}',
    longFormatting: '{minutes} {seconds}',
    timerFormatting: '{minutes}:{seconds}',
    daysUnit: '{value, plural, one {dag} other {dagen}}',
    hoursUnit: '{value, plural, one {uur} other {uren}}',
    minutesUnit: '{value, plural, one {minuut} other {minuten}}',
    secondsUnit: '{value, plural, one {seconde} other {seconden}}',
  },
};



// WEBPACK FOOTER //
// ./src/messages_nl.js